'use client';

import { observer } from 'mobx-react-lite';
import { RootWrapperProps } from './types';
import styles from './RootWrapper.module.scss';
import { Sidebar } from '../Sidebar';
import { useRouter, useSearchParams } from 'next/navigation';
import { useEffect, useMemo, useTransition } from 'react';
import { authStore } from '@/shared/store/authStore/authStore';
import { CustomLoading } from '@/shared/ui/CustomLoading';
import { AccessGuard } from '@/components/AccessGuard';
import { consumeReturnUrl } from '@/shared/store/authStore/models/returnUrl';

export const RootWrapper = observer(({ children }: RootWrapperProps) => {

  const searchParams = useSearchParams();
  const router = useRouter();
  const [isLoading, setTransition] = useTransition();
  const userInfo = useMemo(() => authStore.state.userInfo, [authStore.state.userInfo]);

  useEffect(() => {
    setTransition(() => {
      const code = searchParams.get("code") || "";
      const redirectUri = window.location.origin;
      (async () => {
        try {
          const tokens = await authStore.async.refresh(code, redirectUri);
          if (tokens) {
            await authStore.async.fetchPostUserLogin();
            await authStore.async.fetchUserInfo(tokens.access_token);
            if (code) {
              router.replace(consumeReturnUrl() || '/empty');
            }
          }
        } catch (e) {
          const redirectUri = window.location.origin;
          await authStore.async.logout(redirectUri);
        }
      })();
    });
  }, []);
  if(userInfo === null || isLoading) return <CustomLoading />;
  
  return (
    <div className={styles.container}>
      <div className={styles.sideBarContainer}>
        <Sidebar />
      </div>
      <div className={styles.contentContainer}>
        <AccessGuard>
          {children}
        </AccessGuard>
      </div>
    </div>
  );
});
